var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContainerDeliveries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75C4.73 22.75 1.25 19.27 1.25 15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15C2.75 17.96 4.81 20.44 7.58 21.09L7.31 20.64C7.1 20.28 7.21 19.82 7.57 19.61C7.92 19.4 8.39 19.51 8.6 19.87L9.65 21.62C9.79 21.85 9.79 22.14 9.66 22.37C9.52 22.6 9.27 22.75 9 22.75Z",
    fill: "#2E4347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0004 9.75C21.5904 9.75 21.2504 9.41 21.2504 9C21.2504 6.04 19.1904 3.56 16.4204 2.91L16.6904 3.36C16.9004 3.72 16.7904 4.18 16.4304 4.39C16.0804 4.6 15.6104 4.49 15.4004 4.13L14.3504 2.38C14.2104 2.15 14.2104 1.86 14.3404 1.63C14.4804 1.4 14.7304 1.25 15.0004 1.25C19.2704 1.25 22.7504 4.73 22.7504 9C22.7504 9.41 22.4104 9.75 22.0004 9.75Z",
    fill: "#2E4347"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4444 12.5556C16.75 12.5556 17 12.3056 17 12C17 11.6944 16.75 11.4444 16.4444 11.4444H15.8889V8.11111H16.4444C16.75 8.11111 17 7.86111 17 7.55556C17 7.25 16.75 7 16.4444 7H7.55556C7.25 7 7 7.25 7 7.55556C7 7.86111 7.25 8.11111 7.55556 8.11111H8.11111V11.4444H7.55556C7.25 11.4444 7 11.6944 7 12C7 12.3056 7.25 12.5556 7.55556 12.5556H8.11111V15.8889H7.55556C7.25 15.8889 7 16.1389 7 16.4444C7 16.75 7.25 17 7.55556 17H16.4444C16.75 17 17 16.75 17 16.4444C17 16.1389 16.75 15.8889 16.4444 15.8889H15.8889V12.5556H16.4444Z",
    fill: "#2E4347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerDeliveries);
export default __webpack_public_path__ + "static/media/container-deliveries.7440ab8111094e0f951f2ac8d0b5a975.svg";
export { ForwardRef as ReactComponent };